/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header[_ngcontent-%COMP%]{margin:30px 0 20px;text-align:center;font-family:Lato,sans-serif}.header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-bottom:0;font-size:20px;font-weight:bolder;color:#003770}.body[_ngcontent-%COMP%]{height:150px;text-align:center;font-size:14px}"];
export { styles as styles };
